import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import Avatar from "@mui/material/Avatar";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import "./LogIn.css";

const SignIn = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/sign-in/signin`,
        { email, password, role }
      );
      const { token, redirectURL, displayName } = response.data;

      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("email", email);
      localStorage.setItem("displayName", displayName);
      Swal.fire({
        title: "Login Successful",
        text: `Welcome, ${response.data.displayName}`,
        icon: "success",
      });

      navigate(redirectURL);
    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        const status = error.response.status;
        const message = error.response.data.message;

        if (status === 400) {
          Swal.fire({
            title: "Login Failed",
            text: message,
            icon: "error",
          });
        } else if (status === 403) {
          Swal.fire({
            title: "Access Denied",
            text: message,
            icon: "warning",
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "An unexpected error occurred. Please try again later.",
            icon: "error",
          });
        }
      } else {
        Swal.fire({
          title: "Error",
          text: "Unable to connect to the server. Please try again later.",
          icon: "error",
        });
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <Avatar className="login-avatar">
            <LockOutlinedIcon />
          </Avatar>
          <h1>Welcome Back</h1>
          <p>Sign in to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <EmailOutlinedIcon className="input-icon" />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>

          <div className="input-group">
            <LockOpenOutlinedIcon className="input-icon" />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>

          <div className="input-group">
            <AssignmentIndOutlinedIcon className="input-icon" />
            <select
              name="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              required
              disabled={isLoading}
            >
              <option value="" disabled>
                Select Role
              </option>
              <option value="reviewer">Reviewer</option>
              <option value="author">Author</option>
            </select>
          </div>

          <div className="forgot-password-container-l">
            <p>
              Forgot your password?{" "}
              <a href="/forgot-password" className="forgot-password-link">
                Click here
              </a>
            </p>
          </div>

          <button type="submit" disabled={isLoading} className="logInBtn">
            {isLoading ? "Signing In..." : "Sign In"}
          </button>
        </form>

        <div className="login-footer">
          <p>
            Don't have an account? <a href="/sign-up">Create Account</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
